export class Unit {
    static UNIT : Unit = new Unit();
    constructor() {}
}
